import {
  useCopyProtocolDeviationsLogMutation,
  useCreateProtocolDeviationsLogMutation,
  useDeleteAllProtocolDevationsLogMutation,
  useDeleteProtocolDevationsLogMutation,
  useLazyGetProtocolDeviationsLogBasedOnDateRangeQuery,
  useLazyGetProtocolDeviationsLogQuery,
  useUpdateAllProtocolDeviationsLogMutation,
  useUpdateDeviationActionMutation,
  useUpdateDeviationDecisionMutation,
  useUpdateProtocolDeviationsLogMutation
} from 'src/services/protocolDeviationsLog';

export const useProtocolDeviationsLog = () => {
  const [
    getProtocolDeviationLogData,
    {
      data: protocolDeviationsData,
      isLoading: protocolDeviationsIsLoading,
      isError: protocolDeviationsIsError,
      error: protocolDeviationsError,
      isSuccess: protocolDeviationsIsSuccess
    }
  ] = useLazyGetProtocolDeviationsLogQuery();

  const [
    createProtocolDeviationsLog,
    {
      data: createProtocolDeviationsData,
      isLoading: createProtocolDeviationsIsLoading,
      isError: createProtocolDeviationsIsError,
      error: createProtocolDeviationsError,
      isSuccess: createProtocolDeviationsIsSuccess
    }
  ] = useCreateProtocolDeviationsLogMutation();

  const [
    updateProtocolDeviationsLog,
    {
      data: updateProtocolDeviations,
      isLoading: updateProtocolDeviationsIsLoading,
      isError: updateProtocolDeviationsIsError,
      error: updateProtocolDeviationsError,
      isSuccess: updateProtocolDeviationsIsSuccess
    }
  ] = useUpdateProtocolDeviationsLogMutation();

  const [
    deleteProtocolDeviationsLog,
    {
      data: deleteProtocolDeviations,
      isLoading: deleteProtocolDeviationsIsLoading,
      isError: deleteProtocolDeviationsIsError,
      error: deleteProtocolDeviationsError,
      isSuccess: deleteProtocolDeviationsIsSuccess
    }
  ] = useDeleteProtocolDevationsLogMutation();

  const [
    updateDeviationAction,
    {
      data: updateDeviationActionData,
      error: updateDeviationActionError,
      isError: updateDeviationActionIsError,
      isLoading: updateDeviationActionIsLoading,
      isSuccess: updateDeviationActionIsSuccess
    }
  ] = useUpdateDeviationActionMutation();

  const [
    updateDeviationDecision,
    {
      data: updateDeviationDecisionData,
      error: updateDeviationDecisionError,
      isError: updateDeviationDecisionIsError,
      isLoading: updateDeviationDecisionIsLoading,
      isSuccess: updateDeviationDecisionIsSuccess
    }
  ] = useUpdateDeviationDecisionMutation();

  const [
    updateAllProtocolDeviationsLog,
    {
      data: updateAllProtocolDeviations,
      isLoading: updateAllProtocolDeviationsIsLoading,
      isError: updateAllProtocolDeviationsIsError,
      error: updateAllProtocolDeviationsError,
      isSuccess: updateAllProtocolDeviationsIsSuccess
    }
  ] = useUpdateAllProtocolDeviationsLogMutation();

  const [
    deleteAllProtocolDeviationsLog,
    {
      data: deleteAllProtocolDeviations,
      isLoading: deleteAllProtocolDeviationsIsLoading,
      isError: deleteAllProtocolDeviationsIsError,
      error: deleteAllProtocolDeviationsError,
      isSuccess: deleteAllProtocolDeviationsIsSuccess
    }
  ] = useDeleteAllProtocolDevationsLogMutation();

  const [
    copyProtocolDeviationsLog,
    {
      data: copyProtocolDeviationsData,
      isLoading: copyProtocolDeviationsIsLoading,
      isError: copyProtocolDeviationsIsError,
      error: copyProtocolDeviationsError,
      isSuccess: copyProtocolDeviationsIsSuccess
    }
  ] = useCopyProtocolDeviationsLogMutation();

  const [
    getProtocolDeviationLogBasedOnDateRange,
    {
      data: protocolDeviationsBasedOnDateRangeData,
      isLoading: protocolDeviationsBasedOnDateRangeIsLoading,
      isError: protocolDeviationsBasedOnDateRangeIsError,
      error: protocolDeviationsBasedOnDateRangeError,
      isSuccess: protocolDeviationsBasedOnDateRangeIsSuccess
    }
  ] = useLazyGetProtocolDeviationsLogBasedOnDateRangeQuery();

  return {
    getProtocolDeviationLogData,
    protocolDeviationsData,
    protocolDeviationsIsLoading,
    protocolDeviationsIsError,
    protocolDeviationsError,
    protocolDeviationsIsSuccess,
    createProtocolDeviationsLog,
    createProtocolDeviationsData,
    createProtocolDeviationsIsLoading,
    createProtocolDeviationsIsError,
    createProtocolDeviationsError,
    createProtocolDeviationsIsSuccess,
    updateProtocolDeviationsLog,
    updateProtocolDeviations,
    updateProtocolDeviationsIsLoading,
    updateProtocolDeviationsIsError,
    updateProtocolDeviationsError,
    updateProtocolDeviationsIsSuccess,
    deleteProtocolDeviationsLog,
    deleteProtocolDeviations,
    deleteProtocolDeviationsIsLoading,
    deleteProtocolDeviationsIsError,
    deleteProtocolDeviationsError,
    deleteProtocolDeviationsIsSuccess,
    updateDeviationAction,
    updateDeviationActionData,
    updateDeviationActionError,
    updateDeviationActionIsError,
    updateDeviationActionIsLoading,
    updateDeviationActionIsSuccess,
    updateDeviationDecision,
    updateDeviationDecisionData,
    updateDeviationDecisionError,
    updateDeviationDecisionIsError,
    updateDeviationDecisionIsLoading,
    updateDeviationDecisionIsSuccess,
    updateAllProtocolDeviationsLog,
    updateAllProtocolDeviations,
    updateAllProtocolDeviationsIsLoading,
    updateAllProtocolDeviationsIsError,
    updateAllProtocolDeviationsError,
    updateAllProtocolDeviationsIsSuccess,
    deleteAllProtocolDeviationsLog,
    deleteAllProtocolDeviations,
    deleteAllProtocolDeviationsIsLoading,
    deleteAllProtocolDeviationsIsError,
    deleteAllProtocolDeviationsError,
    deleteAllProtocolDeviationsIsSuccess,
    copyProtocolDeviationsLog,
    copyProtocolDeviationsData,
    copyProtocolDeviationsIsLoading,
    copyProtocolDeviationsIsError,
    copyProtocolDeviationsError,
    copyProtocolDeviationsIsSuccess,
    getProtocolDeviationLogBasedOnDateRange,
    protocolDeviationsBasedOnDateRangeData,
    protocolDeviationsBasedOnDateRangeIsLoading,
    protocolDeviationsBasedOnDateRangeIsError,
    protocolDeviationsBasedOnDateRangeError,
    protocolDeviationsBasedOnDateRangeIsSuccess
  };
};
